import { ActionMenuItem } from '../../commons/components/GrowegyMenu';
import { EyeIcon } from '../../assets/icons';

export const restartOnboardingMenuItem = (
  isHidden: boolean,
  onClick: () => void
): ActionMenuItem => {
  return {
    type: 'standard',
    text: 'Restart onboarding',
    icon: <EyeIcon />,
    isHidden,
    onClick: () => onClick(),
  };
};
